/**
 * @generated SignedSource<<cc3cf2a64f747164169cdfdc5c104932>>
 * @relayHash 08015e7d270186615e5e441b5ba5b19e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d484fd375d5517a59ee15571537b85c70a57ff8635724fdb1a1ee38a8d22ac6e

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSetIssueSearchHierarchyEnabledInput = {
  hierarchyEnabled: boolean;
  viewId: string;
};
export type HierarchyToggleMutation$variables = {
  input: JiraSetIssueSearchHierarchyEnabledInput;
};
export type HierarchyToggleMutation$data = {
  readonly jira_setIssueSearchHierarchyEnabled: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type HierarchyToggleMutation = {
  response: HierarchyToggleMutation$data;
  variables: HierarchyToggleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "JiraSetIssueSearchHierarchyEnabledPayload",
    "kind": "LinkedField",
    "name": "jira_setIssueSearchHierarchyEnabled",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HierarchyToggleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HierarchyToggleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "d484fd375d5517a59ee15571537b85c70a57ff8635724fdb1a1ee38a8d22ac6e",
    "metadata": {},
    "name": "HierarchyToggleMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ca11cf70f3dd72232cb01be6b2d6279f";

export default node;
